import React from "react";
import {Provider} from "mobx-react";
import set from 'lodash/set';
import mean from 'lodash/mean';
import find from 'lodash/find';
import mapValues from 'lodash/mapValues';
import {observable, toJS} from "mobx";

export default class DataManager extends React.Component {

    uuidToSectionMap = {};
    @observable inputs = new Map();
    @observable averages = new Map();
    @observable year;

    constructor(props) {
        super(props);

        this.year = new Date().getFullYear();

        this.loadFromStorage();
    }

    get year() {
        return this.year;
    }

    registerInput(section, uuid) {
        this.uuidToSectionMap[uuid] = section;
    }

    getValue(uuid, year) {
        let val = this.inputs.get(uuid);

        if (typeof val === 'object' && val[year]) {
            return val[year];
        }

        return null;
    }

    getAverageValue(section_uuid, year) {
        let val = this.averages.get(section_uuid);

        if (typeof val === 'object' && val[year]) {
            return Math.round(val[year] * 100)/100;
        }

        return null;
    }

    updateInputValue(uuid, value = {}) {
        let existing = this.inputs.get(uuid);

        if (!existing) {
            existing = {};
        }

        this.inputs.set(uuid, {...existing, ...value});

        this.calculateAverages();
        this.saveToStorage();
    }

    calculateAverages() {

        let averages = {};
        let average_arrays = {};

        this.inputs.forEach((data, uuid) => {
            let section_uuid = this.uuidToSectionMap[uuid];

            data = toJS(data);

            Object.keys(data).forEach(year => {
                let year_val = data[year];
                let key = [section_uuid, year].join('|');

                if (!average_arrays[key]) {
                    average_arrays[key] = [];
                }

                average_arrays[key].push(year_val);

                if (!averages[section_uuid]) {
                    averages[section_uuid] = {};
                }

                averages[section_uuid][year] = mean(average_arrays[key]);

            });
        });

        Object.keys(averages).forEach(section_uuid => {
            this.averages.set(section_uuid, averages[section_uuid]);
        });

    }

    get graphData() {
        let data = {};

        this.averages.forEach((values, section_uuid) => {
            Object.keys(values).forEach((year, year_index) => {
                let year_avg = values[year];

                set(data, [year, 'data', section_uuid], year_avg);
                set(data, [year, 'meta', 'color'], ['blue', 'red', 'pink', 'yellow', 'green'][year_index]);
            })
        });

        return Object.values(data);
    }

    get storageKey() {
        return 'sustainability-tool-data';
    }

    saveToStorage() {
        localStorage.setItem(
            this.storageKey, JSON.stringify(toJS(this.inputs))
        );
    }

    getLocalStorage(){
        return JSON.parse(
            localStorage.getItem(this.storageKey)
        );
    }

    loadFromStorage() {
        this.inputs.merge(this.getLocalStorage());

        let inputData = require('../data.json');

        this.inputs.forEach((input, key) => {
            let inputObj = find(inputData, ['uuid', key]);

            if(inputObj){
                this.registerInput(inputObj.category, key);
            }
        });

        this.calculateAverages();
    }

    resetInputs() {
        this.inputs.forEach((input, key) => {
            this.inputs.set(key, mapValues(input, () => 1));
        });

        this.calculateAverages();
    }

    render() {
        return (
            <Provider manager={this}>
                <Provider inputs={this.inputs}>
                    <React.Fragment>
                        {this.props.children}
                    </React.Fragment>
                </Provider>
            </Provider>
        );
    }
}